module.exports = __webpack_public_path__ + "static/Dashly-4c2ef94d05e6bcb8935e76f5656cabfc.png";